// extracted by mini-css-extract-plugin
module.exports = {"container":"CdsSuccessPage_container__3qJ2t","message":"CdsSuccessPage_message__1Ew0L"};